module.exports = __webpack_public_path__ + "img/supervision.d6864c77.png";